import { useTranslation } from "next-i18next";
import React from "react";

import styles from "./instore.module.scss";

export const InStoreNoLocations: React.FC = () => {
    const { t } = useTranslation();
    return (
        <div className={styles.instoreListContainer}>
            <p className={styles.instoreNoLocations}>{t("inStore.noStoresFound")}</p>
        </div>
    );
};
